import React, { useState } from "react";

function SidebarApp({ categories, selectedCategory, onSelectCategory, isOpen, onClose }) {
  const [search, setSearch] = useState("");

  const filtered = categories.filter(cat =>
    cat.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? "active" : ""}`}
        onClick={onClose}
        style={{
          display: isOpen ? "block" : "none",
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 998,
        }}
      />

      <div
        className={`responsive-sidebar ${isOpen ? "open" : ""}`}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          background: "#0f172a",
          borderRight: "1px solid #1e293b",
          overflow: "hidden",
        }}
      >
        {/* ── Header ── */}
        <div style={{
          padding: "20px 16px 12px",
          borderBottom: "1px solid #1e293b",
          flexShrink: 0,
        }}>
          <div style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.12em",
            color: "#475569",
            textTransform: "uppercase",
            marginBottom: 10,
          }}>
            Topics
          </div>

          {/* Search box */}
          <div style={{ position: "relative" }}>
            <span style={{
              position: "absolute",
              left: 9,
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: 13,
              color: "#475569",
              pointerEvents: "none",
            }}>🔍</span>
            <input
              type="text"
              placeholder="Filter..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "7px 10px 7px 30px",
                background: "#1e293b",
                border: "1px solid #334155",
                borderRadius: 7,
                color: "#e2e8f0",
                fontSize: 13,
                outline: "none",
                boxSizing: "border-box",
              }}
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                style={{
                  position: "absolute",
                  right: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  color: "#64748b",
                  cursor: "pointer",
                  fontSize: 14,
                  lineHeight: 1,
                  padding: 0,
                }}
              >✕</button>
            )}
          </div>

          {/* Count badge */}
          <div style={{
            marginTop: 8,
            fontSize: 11,
            color: "#475569",
          }}>
            {filtered.length} of {categories.length} topics
          </div>
        </div>

        {/* ── Scrollable category list ── */}
        <ul style={{
          listStyle: "none",
          padding: "8px 0",
          margin: 0,
          overflowY: "auto",
          flex: 1,
          // Custom scrollbar
          scrollbarWidth: "thin",
          scrollbarColor: "#334155 transparent",
        }}>
          {filtered.length === 0 ? (
            <li style={{
              padding: "20px 16px",
              color: "#475569",
              fontSize: 13,
              textAlign: "center",
            }}>
              No matches found
            </li>
          ) : (
            filtered.map(cat => {
              const isActive = selectedCategory === cat;
              return (
                <li key={cat}>
                  <button
                    onClick={() => onSelectCategory(cat)}
                    style={{
                      width: "100%",
                      padding: "9px 16px",
                      border: "none",
                      background: isActive
                        ? "linear-gradient(90deg, #1d4ed8 0%, #1e40af 100%)"
                        : "transparent",
                      textAlign: "left",
                      cursor: "pointer",
                      fontSize: "0.875em",
                      color: isActive ? "#fff" : "#94a3b8",
                      fontWeight: isActive ? 600 : 400,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      borderRadius: isActive ? 0 : 0,
                      borderLeft: isActive ? "3px solid #60a5fa" : "3px solid transparent",
                      transition: "background 0.15s, color 0.15s",
                      letterSpacing: "0.01em",
                    }}
                    onMouseEnter={e => {
                      if (!isActive) {
                        e.currentTarget.style.background = "#1e293b";
                        e.currentTarget.style.color = "#e2e8f0";
                      }
                    }}
                    onMouseLeave={e => {
                      if (!isActive) {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.color = "#94a3b8";
                      }
                    }}
                  >
                    <span style={{
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      background: isActive ? "#60a5fa" : "#334155",
                      flexShrink: 0,
                      transition: "background 0.15s",
                    }} />
                    {cat}
                  </button>
                </li>
              );
            })
          )}
        </ul>

        {/* ── Footer ── */}
        {selectedCategory && (
          <div style={{
            padding: "10px 16px",
            borderTop: "1px solid #1e293b",
            flexShrink: 0,
          }}>
            <div style={{
              fontSize: 11,
              color: "#475569",
              marginBottom: 4,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
            }}>Active</div>
            <div style={{
              fontSize: 12,
              color: "#60a5fa",
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}>
              ▶ {selectedCategory}
            </div>
          </div>
        )}
      </div>

      <style>{`
        .responsive-sidebar::-webkit-scrollbar {
          width: 4px;
        }
        .responsive-sidebar::-webkit-scrollbar-track {
          background: transparent;
        }
        .responsive-sidebar::-webkit-scrollbar-thumb {
          background: #334155;
          border-radius: 2px;
        }
      `}</style>
    </>
  );
}

export default SidebarApp;
